module.exports = __webpack_public_path__ + "static/img/config_textos.3ff6274.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config/config_textos.jpg
// module id = 6fwK
// module chunks = 1